import { Component, Input, ViewChildren, QueryList, Output, EventEmitter, OnInit, AfterViewInit } from '@angular/core';
import { AutoGroupDropdown } from '../../../../../models/group-settings';
import { AutoGroupSourceItemComponent } from './auto-group-source-item/auto-group-source-item.component';
import { CommonConstant } from '../../../../app.constants';
import { AutoGroupSource, AutoGroupSourceEnum } from '../../../../../models/auto-group/auto-group-setting';
import { UserService } from '../../../../services/user.service';
import {BrandedSignUp} from '../../../../../models/auto-group/branded-sign-up';
import {CacheService} from '../../../../services/cache/cache.service';

@Component({
  selector: 'auto-group-sources',
  templateUrl: './auto-group-sources.component.html',
  styleUrls: ['./auto-group-sources.component.scss']
})
export class AutoGroupSourcesComponent implements OnInit, AfterViewInit {
  @ViewChildren(AutoGroupSourceItemComponent) autoGroupSourceItemList: QueryList<AutoGroupSourceItemComponent>;

  @Input() isIdentifyRelevantInfluencersOn: boolean | false;
  @Input() autoGroupSourceList: Array<AutoGroupDropdown> = [];
  @Input() listProject: any  = [];
  @Input() campaignList: Array<AutoGroupDropdown> = [];
  @Input() influencerGroupList: Array<any> = [];
  @Input() autoGroupSource: Array<AutoGroupSource> = [];
  @Input() influencerGroupId: number;
  @Input() brandedSignUpConfig: BrandedSignUp;

  @Input() showSourceRequiredErrorMessage: boolean;
  @Output() showSourceRequiredErrorMessageChange = new EventEmitter<boolean>();

  @Output() editOrCreateProjectEvent: EventEmitter<any> = new EventEmitter<any>();

  private autoGroupSourceItem: AutoGroupSource = new AutoGroupSource();
  public availableAutoGroupSourceList: Array<AutoGroupDropdown> = [];

  constructor(private userService: UserService, private cacheService: CacheService) {}

  ngOnInit() {
    this.loadGroupSourceData();
    this.loadSourceList();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.autoGroupSourceItemList.forEach(sourceItem => this.changeGroupSourceEvent(sourceItem.sourceItem));
    }, 100);
  }

  private loadSourceList() {
    this.availableAutoGroupSourceList = this.autoGroupSourceList;
  }

  private loadGroupSourceData() {
    this.cacheService.get(`${CommonConstant.BRANDED_SIGNUP_CONFIG_KEY}_${this.userService.getCompanyId()}`,
      this.userService.getSignUpPageData(this.userService.getCompanyId())).subscribe(res => {
        if (!res) {
          if (!this.autoGroupSource || (this.autoGroupSource && this.autoGroupSource.length === 0)) {
            this.autoGroupSource = [this.autoGroupSourceItem];
          }
        } else {
          const grouSourceItem = new AutoGroupSource();
          grouSourceItem.type = AutoGroupSourceEnum.BRANDED_SIGNUP;
          if (res.influencerGroupId !== this.influencerGroupId) {
            return;
          }
          if (!this.autoGroupSource || (this.autoGroupSource && this.autoGroupSource.length === 0)) {
            this.autoGroupSource.push(grouSourceItem);
          } else {
            if (this.autoGroupSource.filter(item => item.type === AutoGroupSourceEnum.BRANDED_SIGNUP).length > 0) {
              return;
            }
            this.autoGroupSource.unshift(grouSourceItem);
          }
      }
    });
  }

  addMoreGroupSources() {
    if (this.autoGroupSource.length >= CommonConstant.MAX_AUTO_GROUP_SOURCE) {
      return;
    }
    this.autoGroupSourceItem = new AutoGroupSource();
    this.autoGroupSource.push(this.autoGroupSourceItem);
    this.showSourceRequiredErrorMessage = false;
    this.showSourceRequiredErrorMessageChange.emit(false);
  }

  changeGroupSourceEvent(evt) {
    this.calculateSupportedSourceList();
  }

  deleteGroupSourceEvent(evt, itemIndex) {
    this.autoGroupSource.splice(itemIndex, 1);
    this.changeGroupSourceEvent(evt);
  }

  get hideAddBtn() {
    return this.autoGroupSource.length >= CommonConstant.MAX_AUTO_GROUP_SOURCE;
  }

  validateAllSources() {
    const sourceErrors = [];
    this.autoGroupSourceItemList.forEach(filter => sourceErrors.push(...filter.validateSources()));
    return sourceErrors;
  }

  editOrCreateProject(project) {
    this.editOrCreateProjectEvent.emit(project);
  }

  private calculateSupportedSourceList() {
    const selectedSourceTypes = this.autoGroupSource.map(gf => gf.type);
    this.availableAutoGroupSourceList = this.autoGroupSourceList.filter(sc => selectedSourceTypes.indexOf(sc.id) < 0);
  }
}



// WEBPACK FOOTER //
// ./src/app/main/group-details/new-group-settings/auto-group-sources/auto-group-sources.component.ts